module.exports = __webpack_public_path__ + "media/images/avatar-cb85409ef161791a02e86728960fe385.png";